export default "__VITE_ASSET__543aced3__$_?react__"